'use client'

import React from 'react'
import { useDeveloperFeatures } from '@/hooks/use-developer-feature'
import { useUserContext } from '@/components/providers'

type DevTypeLabelProps = {
    type: string
}

export function DevTypeLabel({ type }: DevTypeLabelProps) {
    const { isAdmin } = useUserContext()
    const { isFeatureEnabled } = useDeveloperFeatures()
    if (!isFeatureEnabled('markdownTypes')) return null
    
    return (
        <span className="absolute left-0 top-0 -translate-x-full text-red-600 font-bold text-[10px] leading-none pointer-events-none select-none">
            {type}
        </span>
    )
}
